import { render, staticRenderFns } from "./ButtonBoxIcon.vue?vue&type=template&id=dfa91750&scoped=true"
import script from "./ButtonBoxIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonBoxIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ButtonBoxIcon.vue?vue&type=style&index=0&id=dfa91750&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa91750",
  null
  
)

export default component.exports